import Vue from "vue";
import Vuex from "vuex";

import { i18n } from "./../i18n.js"

import level1 from "./../assets/levels/level_1.json"
import level2 from "./../assets/levels/level_2.json"
import level3 from "./../assets/levels/level_3.json"

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    levels: {
      "1": level1,
      "2": level2,
      "3": level3,
      "X": []
    },
    cards: [],
    selectedLevel: "1",
    players: [],
    singlePlayer: false,
    ownLevelSet: false,
    tempLastCard: null,
    language: i18n.locale
  },
  getters: {
    gameInProgress: (state, getters) => {
      return getters.inGame.length > 0;
    },
    neededToWin: (state) => {
      let total = state.cards.length / 2;
      if (total % 2 === 0) {
        return (total/2) + 1;
      } else {
        return Math.ceil(total/2);
      }
    },
    players: (state) => {
      return state.players;
    },
    currentPlayer: (state) => {
      return state.players.filter(p => p.onTurn === true)[0];
    },
    cards: (state) => {
      return state.cards;
    },
    inGame: (state, getters) => {
      return getters.cards.filter(c => c.owner === null)
    },
    inGameUp: (state, getters) => {
      return getters.inGame.filter(c => c.turnedUp === true);
    },
    acquired: (state, getters) => {
      return getters.cards.filter(c => c.owner != null);
    },
    facingUpCount: (state, getters) => {
      return getters.inGameUp.length;
    },
    ownLevelSet: (state) => {
      return state.ownLevelSet;
    },
    selectedLevel: (state) => {
      return state.selectedLevel;
    },
    levels: (state) => {
      let keys = Object.keys(state.levels);
      let levels = {}
      keys.forEach(k => levels[k] = state.levels[k])
      return levels;
    },
    showingMatch: (state, getters) => {
      if (getters.facingUpCount < 2) {
        return false;
      } else {
        return getters.inGameUp[0].text === getters.inGameUp[1].text;
      }
    },
    cardsPerPlayer: (state, getters) => {
      let result = {};
      getters.players.forEach(function(player) {
        result[player.name] = getters.acquired.filter(c => c.owner === player);
      })
      return result;
    },
    tempLastCard: (state) => {
      return state.tempLastCard;
    },
    language: (state) => {
      return state.language;
    },
    playerCount: (state) => {
      return state.singlePlayer ? 1 : 2
    },
    singlePlayer: (state) => {
      return state.singlePlayer
    },
    winner: (state, getters) => {
      let max = 0;
      let winner = null;
      getters.players.forEach(function(player) {
        let count = getters.cardsPerPlayer[player.name].length;
        if (count > max) {
          max = count;
          winner = player;
        } else if (count == max && max > 0) {
          winner = null;
        }
      })
      return winner;
    },
    winnerScore: (state, getters) => {
      if (!getters.winner) return null

      let winner = state.singlePlayer ? state.players[0] : getters.winner
      let cards = getters.cardsPerPlayer[winner.name].length
      return Math.round(cards*100 / winner.tries)
    }
  },
  mutations: {
    turnUp: (state, payload) => {
      payload.card.turnedUp = true;
    },
    increaseTries: (state, payload) => {
      let current = state.players.filter(p => p.onTurn === true)[0];
      current.tries += 1
    },
    clearPlayerTries: (state) => {
      state.players.forEach(player => player.tries = 0)
    },
    hideVisible: (state) => {
      state.cards
        .filter(c => c.owner === null && c.turnedUp === true)
          .forEach(c => c.turnedUp = false)
    },
    acquire: (state) => {
      let up = state.cards.filter(c => c.owner === null && c.turnedUp === true);

      if (up.length === 2 && up[0].text === up[1].text) {
        let current = state.players.filter(p => p.onTurn === true)[0];
        up.forEach(card => card.owner = current);
        up.forEach(function(card) {
          let i = state.cards.indexOf(card);
          state.cards.splice(i, 1, card);
        })
      }
    },
    nextRound: (state) => {
      if (state.singlePlayer) return 

      let current = state.players.filter(p => p.onTurn === true)[0];
      let currentIndex = state.players.indexOf(current);
      let waiting = state.players.filter(p => p.onTurn === false)[0];
      let waitingIndex = state.players.indexOf(waiting);

      waiting.onTurn = true;
      current.onTurn = false;

      state.players.splice(currentIndex, 1, current);
      state.players.splice(waitingIndex, 1, waiting);
    },
    initCards: (state) => {
      let cards = [];
      let method = state.language == "en" ? "name" : "name_cs"
      state.levels[state.selectedLevel].map(bird => {
        if (state.selectedLevel === "X") {
          cards.push({ text: bird[method], turnedUp: false, owner: null, sound: new Howl({src: [bird.filename]}) })
          cards.push({ text: bird[method], turnedUp: false, owner: null, sound: new Howl({src: [bird.filename]}) })
        } else {
          cards.push({ text: bird[method], turnedUp: false, owner: null, license: bird.cc, sound: new Howl({src: [`src/assets/sounds/${bird.filename}`]}) })
          cards.push({ text: bird[method], turnedUp: false, owner: null, license: bird.cc, sound: new Howl({src: [`src/assets/sounds/${bird.filename}`]}) })
        }
      });
      state.cards = cards.sort(function(a, b) { return (0.5 - Math.random()) });
    },
    selectLevel: (state, level) => {
      state.selectedLevel = level;
    },
    setPlayers: (state, payload) => {
      let players = payload;
      players.forEach((player, index) => {
        player.onTurn = index % 2 === 0;
      })
      state.players = players;
    },
    setTempLastCard: (state, payload) => {
      state.tempLastCard = payload.card;
    },
    clearTempLastCard: (state) => {
      state.tempLastCard = null;
    },
    setLanguage: (state, payload) => {
      state.language = payload;
    },
    storeCustomLevel: (state, payload) => {
      state.levels["X"] = payload;
      state.ownLevelSet = true;
    },
    toggleSinglePlayer: (state, payload) => {
      state.singlePlayer = payload["singlePlayer"]
    }
  },
  actions: {
    initCards: ({commit}) => {
      commit("initCards");
    },
    turnUp: ({commit}, payload) => {
      commit("turnUp", payload);
      commit("setTempLastCard", payload);
      commit("increaseTries", payload)
    },
    hide: ({commit}, payload) => {
      commit("hideVisible");
      commit("clearTempLastCard");
    },
    acquire: ({commit}) => {
      commit("acquire");
      commit("clearTempLastCard");
    },
    nextRound: ({commit}) => {
      commit("hideVisible");
      commit("nextRound");
    },
    selectLevel: ({commit}, payload) => {
      commit("selectLevel", payload);
    },
    setPlayers: ({commit}, payload) => {
      commit("setPlayers", payload);
    },
    clearPlayerTries: ({commit}) => {
      commit("clearPlayerTries")
    },
    setLanguage: ({commit}, payload) => {
      commit("setLanguage", payload);
    },
    storeCustomLevel: ({commit}, payload) => {
      commit("storeCustomLevel", payload);
    },
    toggleSinglePlayer: ({commit}, payload) => {
      commit("toggleSinglePlayer", payload);
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js